<div class="modal-overlay">
  <div class="modal-content"*ngIf="showedit=== false">
    <div class="modal-header">
      <h2 *ngIf="superadmin">Edit Super Admin</h2>
       <h2 *ngIf="!superadmin">Edit Admin</h2>
      <!-- <button class="close-btn position-absolute top-0 end-0" (click)="onCancel()">✖</button> -->
    </div>
    <div class="modal-body">
      <form #adminForm="ngForm" (ngSubmit)="onUpdate(adminForm)">
        <div class="form-row">
          <div class="form-group">
            <input 
              type="text" 
              class="capitalize"
              [(ngModel)]="updatedAdmin.first_name" 
              name="firstName" 
              placeholder="First Name" 
              required 
              #first_name="ngModel" maxlength="30" (keypress)="allowOnlyLetters($event)"/>
            <div *ngIf="first_name.invalid && (first_name.dirty || first_name.touched)" class="error">
              First Name is required.
            </div>
          </div>
          <div class="form-group">
            <input 
              type="text" 
              [(ngModel)]="updatedAdmin.last_name" 
              name="lastName" 
              maxlength="30" 
              placeholder="Last Name" 
              required 
              #lastName="ngModel"class="capitalize" (keypress)="allowOnlyLetters($event)" />
            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="error">
              Last Name is required.
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group country-code-group">
             <span class="Password" (click)="openDropdown($event)">
          <span class="pickup-country">{{updatedAdmin.country_code}}</span>
            <select 
              [(ngModel)]="updatedAdmin.country_code" 
              name="countryCode" 
              required 
              #countryCode="ngModel">
              <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                      <span class="mx-3 fw-bold">{{country.name+" "+ country.dial_code }}</span>
                    </option>
              <!-- Add more country codes as needed -->
            </select>
            </span>
          </div>
          <div class="form-group phone-number-group">
            <!-- <input 
              type="text" 
             [ngModel]="updatedAdmin.phone_number === 'Not Available' ? 'NA' : updatedAdmin.phone_number" 
              name="phoneNumber" 
              placeholder="Phone Number" 
              required 
              pattern="[0-9]{10}" 
              [disabled]="updatedAdmin.phone_number === 'Not Available' "
              #phoneNumber="ngModel" /> -->
              <input type="text"
  [(ngModel)]="phoneInput"
  name="phoneNumber"
  placeholder="Phone Number"
  required
  pattern="(^NA$)|(^[0-9]{10}$)"
  #phoneNumber="ngModel" maxlength="10"  [value]="phoneInput !== 'NA' ? phoneInput : ''"  (keypress)="allowOnlyNumbers($event)" />

            <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)" class="error">
              <div *ngIf="phoneNumber.errors?.['required']">Phone Number is required.</div>
              <div *ngIf="phoneNumber.errors?.['pattern']">Phone Number must be 10 digits.</div>
            </div>
          </div>
          <div class="form-group email-group">
            <input 
              type="email" 
              [(ngModel)]="updatedAdmin.email" 
              name="email" 
              placeholder="Email" 
              required 
              email 
              #email="ngModel" disabled/>
            <div *ngIf="email.invalid && (email.dirty || email.touched)" class="error">
              <div *ngIf="email.errors?.['required']">Email is required.</div>
              <div *ngIf="email.errors?.['email']">Please enter a valid email.</div>
            </div>
          </div>
        </div>
        <div class="form-row">
  <div class="form-group">
    <select 
      [(ngModel)]="optionType"
       name="optionType"
      class="Pro_input_Field CompanyField"
      required>
        <option value="" disabled>Choose Admin Access</option>
        <option value="shipping">Shipping</option>
        <option value="receiving">Receiving</option>
        <option value="both">Both</option>
    </select>
  </div>
    <!-- <div class="form-group">
            <input 
              type="text" 
              [(ngModel)]="updatedAdmin.last_name" 
              name="lastName" 
              maxlength="30" 
              placeholder="Last Name" 
              required 
              #lastName="ngModel"class="capitalize" (keypress)="allowOnlyLetters($event)" />
            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="error">
              Last Name is required.
            </div>
          </div> -->
</div>


        <div class="modal-footer">
          <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
          <button type="submit" class="update-btn">Update</button>
        </div>
      </form>
    </div>
  </div>
   <div class="modal-content" *ngIf="showedit === true">
    <!-- <div class="modal-header">
      <h2>Send OTP</h2>
    </div>

    <div class="modal-body">
      <div class="form-row otp-buttons-row">
        <div class="form-group" style="justify-content: center !important;
    align-items: center !important;">
          <button 
            type="button" 
            class="otp-btn" (click)="onPhoneClick()">
             Phone Number
          </button>
        </div>
       
      </div>
       <div class="form-row otp-buttons-row">
       <div class="form-group" style="justify-content: center !important;
    align-items: center !important;">
          <button 
            type="button" 
            class="otp-btn" (click)="onEmailClick()">
             Email
          </button>
        </div>
       
      </div>

      <div class="modal-footer" style="    margin-top: 0px;">
        <button type="button" class="cancel-btn" (click)="onCancel()">Close</button>
      </div>
    </div> -->
     <div class="modal-header" style="justify-content: flex-start;">
      <h2>Verify Identity</h2>
      <!-- <button class="close-btn">×</button> -->
    </div>
    <p>Choose how you'd like to receive your verification code</p>
    <div class="verification-methods">
      <div class="method" [class.selected]="selectedMethod === 'phone'"  (click)="selectMethod('phone')">
         <i class="fa-thin fa-phone"></i>
        <span>Phone</span>
      </div>
      <div class="method" [class.selected]="selectedMethod === 'email'"  (click)="selectMethod('email')">
        <!-- <img src="https://img.icons8.com/ios/50/000000/email.png" alt="Email Icon"> -->
         <i class="fa-thin fa-envelope"></i>
        <span>Email</span>
      </div>
    </div>
    <div class="input-group">
      <label for="phone-number"> {{ selectedMethod === 'phone' ? 'Phone Number' : 'Email Address' }}</label>
      <input type="text" id="phone-number" [value]="selectedValue" style="    width: 100%;
    height: 45px;
    border-radius: 15px;
    border: 1px solid #ccd2d8;
    padding-left: 15px;
    font-size: inherit;"  disabled>
      <i  *ngIf="selectedMethod === 'phone'" class="fa-thin fa-phone input-icon"></i>
    <i  *ngIf="selectedMethod === 'email'" class="fa-thin fa-envelope input-icon" ></i>
    </div>
    <button class="send-btn" (click)="onSendClick()">
      <i class="fa fa-paper-plane"></i>
      Send Verification Code
    </button>
    <button class="close-btn-footer" (click)="onCancel()">Close</button>
  </div>
</div>